import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3efc3016"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Resolve ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icm_menu_item = _resolveComponent("icm-menu-item")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createBlock(_component_icm_menu_item, {
    style: {"width":"210px"},
    clickable: "",
    class: "agent-cloud-buld-list--item",
    "data-testid": "resolve-action",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.releaseLicenses()))
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  })), [
    [_directive_close_popup]
  ])
}